define(['jquery'], function($) {

    'use strict';

    var cacheJSON = {

        init: function (id, url, ttl) {
            this.id = id;
            this.url = url;
            this.ttl = ttl;
            return this.getCache(id);
        },

        // Caching JSON in LocalStorage — related functions

        // add JSON data as 'value' to LocalStorage with timestamp and TTL (time to live) (key = productID)
        setLsItem: function ( key, value, ttl ) {
            // Remove the oldest saved product after reaching the cache limit
            const keysLimit = 400
            if (localStorage.length >= keysLimit) {
                const keys = Object.keys(localStorage);
                const productsCacheData = [];
                for (let key of keys) {
                    if (key.includes('product-')) {
                        productsCacheData.push({
                            id: key,
                            ...JSON.parse(localStorage.getItem(key)),
                        });
                    }
                }
                if (productsCacheData?.length) {
                    const oldestProduct = productsCacheData?.reduce((prev, curr) => {
                        return prev.date < curr.date ? prev : curr;
                    });
                    localStorage.removeItem(oldestProduct.id);
                }
            }
            localStorage.setItem( 'product-' + key, JSON.stringify({
                ttl   : ttl || 0,
                date  : $.now(),
                value : value
            }) );
        },

        // get item from local storage if exists & hasn't expired yet
        getLsItem: function ( key ) {
            var entry = JSON.parse(localStorage.getItem('product-' + key)||"0");
            if (!entry) return null;
            // if item expired, remove from LocalStorage
            if (entry.ttl && entry.ttl + entry.date < $.now()) {
                localStorage.removeItem(key);
                return null;
            }
            return entry.value;
        },

        // fetch upsell data via AJAX call
        getJSON: function (id) {
            var url = this.url;
            var promise = $.ajax({
                dataType: "json",
                url: url,
                cache: true
            });

            promise.done(function(data) {
                // store item in LocalStorage, get lifetime (TTL) from config
                cacheJSON.setLsItem(id, data, cacheJSON.ttl);
            });

            return promise;
        },

        // check if we have the JSON data cached in Local Storage — if so, fetch data
        getStorage: function (id) {
            var storageDfd = new $.Deferred(),
                storedData = this.getLsItem(id);

            if (!storedData) {
                return this.getJSON(id);
            }

            setTimeout(function() {
                storageDfd.resolveWith(null, [storedData]);
            });

            return storageDfd.promise();
        },

        getCache: function (id) {
            var supportsLocalStorage = 'localStorage' in window;
            // check if browser has LocalStorage, if not, skip and fetch via AJAX
            return supportsLocalStorage ? this.getStorage( id ) : this.getJSON( id );
        }

        // end of caching related functions

    };

    return function (id, url, ttl) {
        return cacheJSON.init(id, url, ttl);
    }

});

